import React, { useState } from "react";
import { X } from "lucide-react";
import Loader from "./Loader";
import toast from "react-hot-toast";
import { useRef, useEffect } from "react";


export default function CheckoutModal({
  checkoutFormOpen,
  setCheckoutFormOpen,
  isFormAnimating,
  setIsFormAnimating,
  handleInputChange,
  handleCheckout,
  customerDetails,
  cartTotal,
}) {
  
  const [isProcessing, setIsProcessing] = useState(false);
  const videoRefs = useRef([]);
  const handleClose = () => {
    setIsFormAnimating(false);
    setTimeout(() => {
      setCheckoutFormOpen(false);
    }, 300);
  };
  const handlePayment = async () => {
    const { name, email, phone, address, pincode } = customerDetails;

    if (!name || !email || !phone || !address || !pincode) {
      toast.error("Please fill all fields");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address");
      return;
    }

    if (phone.length !== 10) {
      toast.error("Please enter a valid 10-digit phone number");
      return;
    }

    if (pincode.length !== 6) {
      toast.error("Please enter a valid 6-digit pincode");
      return;
    }

    try {
      setIsProcessing(true);

      await handleCheckout();
    } catch (error) {
      toast.error("Payment failed. Please try again.");
    } finally {
      setIsProcessing(false);
    }
  };
  return (
    <>
      {/* {isProcessing && <Loader fullScreen size="large" />} */}
      {isProcessing}

      {checkoutFormOpen && (
        <>
          <div
            className={`fixed inset-0 bg-black z-50 transition-opacity duration-300 ease-out ${
              isFormAnimating ? "opacity-50" : "opacity-0"
            }`}
            onClick={handleClose}
          />

          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none">
            <div
              className={`bg-white w-full max-w-md rounded-lg shadow-2xl max-h-[90vh] overflow-y-auto pointer-events-auto transform transition-all duration-300 ease-out ${
                isFormAnimating
                  ? "scale-100 opacity-100 translate-y-0"
                  : "scale-90 opacity-0 translate-y-4"
              }`}
            >
              <div className="p-6 border-b flex justify-between items-center sticky top-0 bg-white z-10">
                <h2 className="text-xl font-medium">Shipping Details</h2>
                <button
                  onClick={handleClose}
                  className="hover:opacity-60 transition"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>

              <div className="p-6 space-y-4">
                {["name", "email", "phone", "address", "pincode"].map(
                  (field, idx) => (
                    <div
                      key={field}
                      className="transform transition-all duration-300"
                      style={{
                        opacity: isFormAnimating ? 1 : 0,
                        transform: isFormAnimating
                          ? "translateY(0)"
                          : "translateY(10px)",
                        transitionDelay: `${75 + idx * 50}ms`,
                      }}
                    >
                      <label className="block text-sm font-medium mb-2">
                        {field === "name"
                          ? "Full Name"
                          : field === "email"
                            ? "Email"
                            : field === "phone"
                              ? "Phone Number"
                              : field === "address"
                                ? "Complete Address"
                                : "Pincode"}{" "}
                        *
                      </label>

                      {field === "address" ? (
                        <textarea
                          name={field}
                          value={customerDetails[field]}
                          onChange={handleInputChange}
                          placeholder="House No, Street, City"
                          rows="3"
                          className="w-full border border-gray-300 px-4 py-3 rounded focus:border-black focus:outline-none resize-none transition"
                        />
                      ) : (
                        <input
                          type={
                            field === "email"
                              ? "email"
                              : field === "phone" || field === "pincode"
                                ? "tel"
                                : "text"
                          }
                          name={field}
                          value={customerDetails[field]}
                          onChange={handleInputChange}
                          placeholder={
                            field === "name"
                              ? "John Doe"
                              : field === "email"
                                ? "john@example.com"
                                : field === "phone"
                                  ? "9876543210"
                                  : "110001"
                          }
                          maxLength={
                            field === "phone"
                              ? 10
                              : field === "pincode"
                                ? 6
                                : undefined
                          }
                          disabled={isProcessing}
                          className="w-full border border-gray-300 px-4 py-3 rounded focus:border-black focus:outline-none transition"
                        />
                      )}
                    </div>
                  ),
                )}

                <div
                  className="pt-4 border-t transform transition-all duration-300 delay-300"
                  style={{
                    opacity: isFormAnimating ? 1 : 0,
                    transform: isFormAnimating
                      ? "translateY(0)"
                      : "translateY(10px)",
                  }}
                >
                  <div className="flex justify-between mb-4">
                    <span className="font-medium">Total Amount:</span>
                    <span className="text-xl font-bold">₹{cartTotal}</span>
                  </div>

                  <button
                    onClick={handlePayment}
                    disabled={isProcessing}
                    className="w-full bg-black text-white py-3 rounded font-medium hover:bg-gray-800 transition"
                  >
                    {isProcessing ? (
                      <>
                        <Loader size="small" />
                        <span>Processing...</span>
                      </>
                    ) : (
                      "Proceed to Payment"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
